export default __webpack_public_path__ + "static/1.7.6/media/nationalCentreResearchAndDevelopment.683c322c.svg";